import React from 'react'
import BackBtn from '../buttons/BackBtn'
import CloseBtn from '../buttons/CloseBtn'

const Header = ({ text, route, backBtn }) => {
  return (
    <div className='header mt-10 mb-30'>
      {backBtn ? (
        <a className='header__back' onClick={route}>
          <BackBtn />
        </a>
      ) : (
        <a className='header__close' onClick={route}>
          <CloseBtn />
        </a>
      )}
      <h3 className='header__title'>{text}</h3>
    </div>
  )
}

export default Header
